<template>
  <div class="report-container">
    <!-- 顶部导航 -->
    <div class="header">
      <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
      <span class="header-title">每月月报</span>
      <div class="placeholder"></div>
    </div>

    <!-- 月报列表 -->
    <div class="report-list">
      <div 
        class="report-card" 
        v-for="(item, index) in reportList" 
        :key="index"
        @click="openReport(item.url)"
      >
        <div class="report-info">
          <div class="report-name">{{ item.name }}</div>
          <div class="report-date">{{ formatDate(item.name) }}</div>
        </div>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-if="reportList.length === 0">
        <div class="empty-text">暂无月报数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { systemMonthlyReport } from '../api/apiList/system';

export default {
  name: 'MonthlyReport',
  data() {
    return {
      reportList: []
    };
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    async getReportList() {
      try {
        const info = await systemMonthlyReport();
        if (info && info.data) {
          this.reportList = info.data;
        }
      } catch (error) {
        console.error('获取月报列表失败:', error);
      }
    },
    openReport(url) {
      if (url) {
        window.location.href = 'https://vip.digitalspark.fund:8000' + url;
      }
    },
    formatDate(name) {
      const match = name.match(/(\d{4}年\d{2}月)/);
      return match ? match[1] : '';
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.report-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #000;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.header-title {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}

.placeholder {
  width: 24px;
}

/* 月报列表 */
.report-list {
  padding: 0 20px;
}

.report-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 12px;
  background-color: #1a1a1a;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.report-card:hover {
  background-color: #222;
}

.report-card:active {
  transform: scale(0.98);
}

.report-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.report-name {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.report-date {
  font-size: 13px;
  color: #36D8AF;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.empty-text {
  font-size: 14px;
  color: #666;
}
</style>
